import { testimonials } from "@/mocks/about";

export default function TestimonialsSection() {
  return (
    <section className="px-6 md:px-10 py-14 md:py-18 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-chat-smile-2-line mr-1.5"></i>
            用户口碑
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            听听吃瓜群众怎么说
          </h2>
          <p className="text-sm text-foreground-500">
            超过580万用户的真实评价，是我们最大的动力
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((item) => (
            <div
              key={item.name}
              className="p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 flex flex-col"
            >
              {/* Rating stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i
                      className={`text-sm ${
                        i < item.rating
                          ? "ri-star-fill text-amber-400"
                          : "ri-star-line text-foreground-300"
                      }`}
                    ></i>
                  </div>
                ))}
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed mb-5 flex-1">
                "{item.content}"
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                <div
                  className={`w-10 h-10 rounded-full ${item.avatarBg} flex items-center justify-center shrink-0`}
                >
                  <span className="text-sm font-bold text-background-50 dark:text-foreground-950">
                    {item.avatarInitial}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}